var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    viewBox: "0 0 256 256",
    width: "256px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12903",
    transform: "translate(5.2843215,-27.050539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.61568,73.929418 A 40.208108,40.208108 0 0 0 66.209131,106.14899 c -13.924496,6.96865 -23.447509,21.34193 -23.447509,38.02908 0,1.12659 0.05744,2.23945 0.142621,3.34346 -12.293534,7.43646 -20.477756,20.928 -20.477756,36.40249 0,23.55548 18.963438,42.51892 42.518919,42.51892 l 115.540544,0 c 23.55548,0 42.51892,-18.96344 42.51892,-42.51892 0,-20.39369 -14.21858,-37.33545 -33.32081,-41.51877 -0.92406,-22.72618 -19.51275,-40.7461 -42.47378,-40.7461 l -3.4247,0 a 40.208108,40.208108 0 0 0 -38.1699,-27.729732 z",
    id: "rect9844",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      fill: "#edfafc",
      fillOpacity: 1,
      stroke: "#b3ddf6",
      strokeWidth: 18.48648643,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.943177,166.55663 -13.076364,35.0489 a 14.072974,14.072974 0 0 0 -0.660212,1.76895 l -0.323529,0.86713 0.102262,-6e-4 a 14.072974,14.072974 0 0 0 -0.363601,3.12168 14.072974,14.072974 0 0 0 14.07326,14.07267 14.072974,14.072974 0 0 0 14.072667,-14.07267 14.072974,14.072974 0 0 0 -0.41981,-3.35072 l 0.0185,0 -0.0491,-0.13694 a 14.072974,14.072974 0 0 0 -0.86653,-2.41722 L 92.943177,166.55663 Z",
    id: "path12847",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      fill: "#64c5ff",
      fillOpacity: 1,
      stroke: "#64c5ff",
      strokeWidth: 16.63045883,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.39368,180.73561 -13.38371,35.8727 a 14.403749,14.403749 0 0 0 -0.67573,1.81053 l -0.33113,0.88751 0.10464,-6.1e-4 a 14.403749,14.403749 0 0 0 -0.37214,3.19505 14.403749,14.403749 0 0 0 14.40405,14.40344 14.403749,14.403749 0 0 0 14.40344,-14.40344 14.403749,14.403749 0 0 0 -0.42969,-3.42948 l 0.019,0 -0.0502,-0.14015 a 14.403749,14.403749 0 0 0 -0.8869,-2.47404 L 160.3937,180.73561 Z",
    id: "path12847-6",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      fill: "#64c5ff",
      fillOpacity: 1,
      stroke: "#64c5ff",
      strokeWidth: 17.02134514,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.c335bd769e2e13c071bff6423b490984.svg";
export { ForwardRef as ReactComponent };